<template>
    <div class="col-xs-12">
        <h4 class="mid-hr mt-4 mb-4 pb-1">{{title}}</h4>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    props:['title']
}
</script>
<style scoped>
  h4{
    color:#101826;
    border-left:3px solid  var(--color-system-primary);
    padding-left:5px;
  }
  
</style>